<template>
    <div v-if="$web.isDesktop">

        <h1 class="desktop-title">
            Risultato dell'analisi
        </h1>

        <div class="desktop-card" :class="{loading}">
            <!-- Loading -->
            <div v-if="loading" class="loader-container">
                <div>
                    <img src="../assets/loader.svg" class="loading-image" alt="Loading">
                    <div class="loading-text" v-text="contents.loading"/>
                    <div class="loading-subtext" v-text="contents.loading_subtitle"/>
                </div>
            </div>

            <!-- Content -->
            <div v-else>

                <!-- Report content -->
                <DesktopReport :report="reportData.report" :more-action="ctaAction"/>

                <div class="row">
                    <div class="col">
                        <!-- Back button -->
                        <Btn
                                @click="newReport"
                                type="secondary"
                                :text="contents.back"/>
                    </div>

                    <div class="col">
                        <!-- Call to action -->
                        <Btn :text="contents.cta" @click="ctaAction"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="web-page" v-else>

        <!-- Top sticky bar -->
        <div class="top-static-bar">

            <!-- Logo -->
            <TopLogo :plain="true"/>

        </div>

        <!-- Scroll content area -->
        <div class="scroll-area">

            <!-- Loading -->
            <div v-if="loading" class="loader-container">
                <div>
                    <img src="../assets/loader.svg" class="loading-image" alt="Loading">
                    <div class="loading-text" v-text="contents.loading"/>
                    <div class="loading-subtext" v-text="contents.loading_subtitle"/>
                </div>
            </div>

            <!-- Content -->
            <div v-else>

                <!-- Report content -->
                <div v-html="report"/>

                <!-- Back button -->
                <Btn
                        @click="newReport"
                        type="secondary"
                        class="mt-3"
                        :text="contents.back"/>

            </div>
        </div>

        <!-- Footer sticky area -->
        <div class="footer">

            <!-- Call to action -->
            <Btn :text="contents.cta" @click="ctaAction"/>

        </div>
    </div>
</template>

<script>
    import contents from "../contents/report"
    import TopLogo from "../components/TopLogo";
    import Btn from "../components/Btn";
    import DesktopReport from "../components/DesktopReport";

    export default {
        name: 'report',
        mounted(){
            this.$registerEvent('Pagina', '8. Visualizzazione REPORT');
        },
        async created() {
            let loaderPromise = new Promise(resolve => setTimeout(() => resolve(), 3000));
            try {
                this.reportData = await this.$api.getReport(
                    this.$store.state.last_profile_UUID
                );
            } catch (e) {
                this.$router.back();
                throw e;
            }
            this.report = this.$loadHtml(require('html-loader!../report/report.html'), this.reportData);
            await loaderPromise;
            this.loading = false;
        },
        components: {Btn, TopLogo, DesktopReport},
        data() {
            return {
                loading: true,
                contents,
                report: '',
                reportData: {},
            };
        },
        methods: {
            newReport() {
                this.$store.commit('newReport');
                this.$router.push('/');
            },
            ctaAction(){
                this.$router.push('/recall');
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../styles/colors.scss";

    .desktop-card.loading {
        max-width: 600px;
        margin: 0 auto;
        padding: 80px 40px;
    }

    .web-page {
        overflow: hidden;
        position: relative;
        padding: 0;
        display: flex;
        flex-direction: column;
    }

    .top-static-bar {
        background: #fff;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
        padding: 15px 0;
        position: fixed;
        top: 0;
        height: 60px;
        width: 100%;
    }

    .scroll-area {
        flex: 1;
        max-height: 100%;
        overflow: auto;
        padding: 80px 20px 100px;
    }

    .footer {
        padding: 10px;
        width: 100%;
        box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);
        position: fixed;
        bottom: 0;
        background: #fff;
    }

    .loader-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .loading-image {
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
    }

    .loading-text {
        font-family: "Open Sans",serif;
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        color: $darkGrey;
        text-transform: uppercase;
    }

    .loading-subtext {
        font-family: "Open Sans",serif;
        font-style: italic;
        font-weight: 400;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        color: $mediumGrey;
    }
</style>